// extracted by mini-css-extract-plugin
module.exports = {"contents":"Af","sectionHeading":"Bf"};